import { AgedARReport } from "../AgedARReport";
import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutAgedARResponsibilityReport extends Layout {
    layoutReport: AgedARReport;
    sourceAgedAR: DataSource;
}
